import React, { Component } from "react";
import L from "leaflet";
import { withTranslation } from 'react-i18next';

import SibicCSV from "./SibicCSV";
import EasinCSV from './EasinCSV'

import Spinner from "react-bootstrap/Spinner";
import MapComponent from '../Map/Map'

import "bootstrap/dist/css/bootstrap.min.css";
import '../css/ficha_int.css'


// Imágenes
import iconoSpecie from '../../images/ficha_specie/icono-especie.png'
import iconoDescripcion from '../../images/ficha_specie/icono-descripcion.png'
import iconoHabitat from '../../images/ficha_specie/icono-habitats.png'
import iconoImgs from '../../images/ficha_specie/icono-imagenes.png'
import iconoMapEspecie from '../../images/ficha_specie/icono-mapa-especie.png'
import iconoRefWeb from '../../images/ficha_specie/icono-referencias-web.png'
import iconoRef from '../../images/ficha_specie/icono-referencias.png'
import iconoVias from '../../images/ficha_specie/icono-vias-entrada.png'
import specie_detected from '../../images/ficha_specie/specie_detected.png'
import specie_population from '../../images/ficha_specie/specie_population_estab.png'
import specie_trasloced from '../../images/ficha_specie/specie_trasloced.png'
import check from '../../images/ficha_specie/check.png'
import cross from '../../images/ficha_specie/cross.png'
import web_link from '../../images/ficha_specie/web_link.png'
import { HOST, API_URL } from '../auxiliar/constants'
import i18next from 'i18next';

const utils = require("../auxiliar/aux_functions");
const { capitalize  } = utils;



class SpecieInfo extends Component {


    state = {
        loading: true,
        sibicRecords: [],
        easinRecords: []
    }


    async refreshSpecie(){
        let jsonData = []
            await fetch("https://eei.sibic.org/API/species.php?id=" + this.props.sibicId + "&lang=" + this.props.i18n.language)
            .then(response => response.json())
            .then(data => { jsonData = data })
        this.setState({
            species_info: jsonData
        })
    }

    componentDidMount() {
        this.fetchInitialRecords()
        i18next.on('languageChanged', () => {this.refreshSpecie()})
    }

    async fetchInitialRecords() {

        let sibicRecords = []
        let easinRecords = []
        let easinJsonData = null
        let jsonData = null

        await fetch('https://eei.sibic.org/API/geo2.php')
            .then(response => response.json())
            .then(data => {
                sibicRecords = data.records.map(record => {
                    return {
                        lng: parseFloat(record.longitude),
                        lat: parseFloat(record.latitude),
                        type: 'SIBIC',
                        recId: record.records_id,
                        specId: record.species_id,
                        heat: [parseFloat(record.latitude), parseFloat(record.longitude), "100"]
                    }
                })
            })

            await fetch(`${HOST}${API_URL}/?function=getRecords`)
                .then(response => response.json())
                .then(data => {
                    easinRecords = data.records.map(record => {
                        let rect = L.rectangle(JSON.parse(record.polygon), {})
                        let center = rect.getBounds().getCenter()
                        return {
                            lng: center.lng,
                            lat: center.lat,
                            type: 'EASIN',
                            recId: record.recordId,
                            specId: record.speciesId,
                            heat: [center.lat, center.lng, "100"]
                        }
                    })
                })

            await fetch("https://eei.sibic.org/API/species.php?id=" + this.props.sibicId + "&lang=" + this.props.i18n.language)
            .then(response => response.json())
            .then(data => { jsonData = data })


            if (this.props.easinId) {
                await fetch(`${HOST}${API_URL}/?function=getRecordsCsv&spe=${this.props.easinId}`)
                .then(response => response.json())
                .then(data => { easinJsonData = data })
            }




        this.setState({
            sibicRecords: sibicRecords.filter(sR => sR.specId === this.props.sibicId),
            easinRecords: this.props.easinId ? easinRecords.filter(eR => eR.specId === this.props.easinId) : [],
            species_info: jsonData,
            easinJsonData: easinJsonData,
            loading: false
        })
    }

    /* Nombres comunes */
    common_names(common_names) {
        var names = ''
        var long = common_names.length
        var i = 0
        common_names.forEach(common => {
            i++
            if (i === long) {
                names += common.common_name + '(' + common.language + ')'
            } else {
                names += common.common_name + '(' + common.language + '), '
            }
        })
        return names
    }

    /* ACORDEON DE LAS REFERENCIAS */
    references(references) {
        const { t } = this.props;
        var acord_references = []
        references.forEach((reference, index) => {
            var link = ""
            if (reference.publication_hyperlink !== "") {
                link =
                    <div className="text-right">
                        <a className="btn btn-success text-dark my-3" href={`${reference.publication_hyperlink}`} target="_blank" rel="noreferrer">{t("ficha-verPublicacion")}</a>
                    </div>
            }

            var referenceHtml =
                <div key={index} className="card">
                    <div className="card-header" id={`heading-${index}`} style={{ padding: "0.4rem 1.25rem" }}>
                        <h5 className="mb-0">
                            <button className="btn btn-link" data-toggle="collapse" data-target={`#collapse-${index}`} aria-expanded="true" aria-controls={`collapse-${index}`}>
                                <img className="acordeon_img" src={iconoRef} alt="icono referencias" /> {`${reference.publication_cite}`}
                            </button>
                        </h5>
                    </div>

                    <div id={`collapse-${index}`} className="collapse" aria-labelledby={`heading-${index}`} data-parent="#accordion">
                        <div className="card-body">
                            <div className="card-body-text"><strong><span className="fa-li"><i className="fas fa-angle-right"></i></span>{t("ficha-referencia")} </strong>
                                {reference.reference}
                            </div>
                            {link}
                        </div>
                    </div>
                </div>
            acord_references.push(referenceHtml)
        })
        return acord_references.length > 0 ? acord_references : <p>Sin referencias</p>
    }

    /* Referencias web */
    webpages(webpages) {
        var links = []
        webpages.forEach((webpages, index) => {
            var link = <li key={`${webpages.webpage}_${index}`} className="text-nowrap overflow-hidden"><a className="web_link_text" href={`${webpages.webpage}`} target="_blank" rel="noreferrer"><img className="img_web_link mr-2" src={web_link} alt="link_icon" />{webpages.webpage}</a></li>
            links.push(link)
        })
        return links.length > 0 ? links : <p>Sin referencias</p>
    }

    /* Imágenes */
    images(images) {
        const { t } = this.props;
        var indicators = []
        var inner = []
        var i = 0

        images.forEach((img, index) => {
            let indicator = null
            let item = null
            if ((img.featured === 0 || img.featured === '0') && i === 0) {
                indicator = <li key={`indicator_img_${index}`} data-target="#carouselIndicators" data-slide-to={`${i}`} className="active"></li>
                indicators.push(indicator)
                i++

                item = <div key={`img_${index}`} className="carousel-item active">
                    <img className="d-block w-100" src={"https://admin.eei.sibic.org/assets/img/species/" + img.file_name} alt="First slide" />
                    <div className="carousel-caption d-none d-md-block">
                        <small className="p-1 species_copyright_carousel">&copy; {img.author}</small>
                    </div>
                </div>
                inner.push(item)

            } else if ((img.featured === 0 || img.featured === '0') && i >= 0) {
                indicator = <li key={`indicator_img_${index}`} data-target="#carouselIndicators" data-slide-to={`${i}`}></li>
                indicators.push(indicator)
                i++

                item = <div key={`img_${index}`} className="carousel-item">
                    <img className="d-block w-100" src={"https://admin.eei.sibic.org/assets/img/species/" + img.file_name} alt={`${img.description}`} />
                    <div className="carousel-caption d-none d-md-block">
                        <small className="p-1 species_copyright_carousel">&copy; {img.author}</small>
                    </div>
                </div>
                inner.push(item)
            }
        })

        var imgs =
            <div id="carouselIndicators" className="carousel slide" data-ride="carousel">
                <ol className="carousel-indicators">
                    {indicators}
                </ol>
                <div className="carousel-inner">
                    {inner}
                </div>
                <a className="carousel-control-prev" href="#carouselIndicators" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">{t("ficha-prev")}</span>
                </a>
                <a className="carousel-control-next" href="#carouselIndicators" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">{t("ficha-nex")}</span>
                </a>
            </div>

        return imgs
    }

    /* Imagen destacada */
    featured_image(images) {
        var image

        images.forEach(img => {
            if (img.featured === 1 || img.featured === '1') {
                image =
                    <>
                        <img src={"https://admin.eei.sibic.org/assets/img/species/" + img.file_name} alt={img.description} className="imagen-oficial" />
                        <span className="imagen-autor">© {img.author}</span>
                    </>
            }
        })
        return image
    }

    /* Habitats */
    habitats(habitats) {
        var habitats_elements = []

        habitats.forEach((habitat, index) => {
            var image_src = ""

            try {
                image_src = require('../../images/ficha_specie/habitats/' + habitat.img).default
            } catch (error) {

            }

            var item =
                <div  key={`${habitat.habitat}_${index}`} className="col-md-3" style={{ textAlign: "center" }}>
                    <img className="img-fluid icon-124" src={image_src} alt={`${habitat.habitat}`} />
                    <p>{capitalize(habitat.habitat)}</p>
                </div>
            habitats_elements.push(item)
        })
        return habitats_elements
    }

    /* Vías de entrada */
    pathways(pathways) {
        var sp_pathways = []

        pathways.forEach((pathway, index) => {
            var image_src = ""

            try {
                image_src = require('../../images/ficha_specie/pathways/' + pathway.specific_img).default
            } catch (error) {

            }

            var item =
                <div key={`${pathway.specific_pathway}_${index}`} className="col-md-3" style={{ textAlign: "center" }}>
                    <img className="img-fluid icon-124" src={image_src} alt={`${pathway.specific_pathway}`} />
                    <p>
                        {pathway.specific_pathway}
                        <br />
                        <small>{pathway.general_pathway}</small>
                    </p>
                </div>
            sp_pathways.push(item)
        })
        return sp_pathways
    }

    render() {

        if (this.state.loading ) {
            return <SpecieSpinner />
        }

        const { t } = this.props;

        const markers = [].concat(this.state.sibicRecords).concat(this.state.easinRecords)

        return (

            <>
                <div className="col-xl-10 offset-xl-1" id="back" style={{marginLeft: 0, marginBottom: '3rem'}}>
                    <div className="btn btn-link btn-link-dark" onClick={this.props.onBack}>{t("ficha-back")}</div>
                </div>
                <div className="col-xl-10 offset-xl-1" id="anclas">
                    <div className="ancla">
                        <a href="#especie" target="_self" title="Especie" className="ancla-enlace">
                            <img src={iconoSpecie} alt="icono especie" />
                        {t("ficha-especie")}
                    </a>
                    </div>

                    <div className="ancla">
                        <a href="#descripcion" target="_self" title="Descripción" className="ancla-enlace">
                            <img src={iconoDescripcion} alt="icono buscador" />
                        {t("ficha-desc")}
                    </a>
                    </div>

                    <div className="ancla">
                        <a href="#generales" target="_self" title="Referencias generales" className="ancla-enlace">
                            <img src={iconoRef} alt="icono referencias" />
                        {t("ficha-ref")}
                    </a>
                    </div>

                    <div className="ancla">
                        <a href="#mapa" target="_self" title="Mapa" className="ancla-enlace">
                            <img src={iconoMapEspecie} alt="icono mapa" />
                        {t("ficha-mapa")}
                    </a>
                    </div>

                    <div className="ancla">
                        <a href="#habitats" target="_self" title="Hábitats" className="ancla-enlace">
                            <img src={iconoHabitat} alt="icono hábitats" />
                        {t("ficha-hab")}
                    </a>
                    </div>

                    <div className="ancla">
                        <a href="#vias" target="_self" title="Vías de entrada" className="ancla-enlace">
                            <img src={iconoVias} alt="icono vías de entrada" />
                        {t("ficha-vias")}
                    </a>
                    </div>

                    <div className="ancla">
                        <a href="#web_ref" target="_self" title="Referencias web" className="ancla-enlace">
                            <img src={iconoRefWeb} alt="icono referencias web" />
                        {t("ficha-web")}
                    </a>
                    </div>

                    <div className="ancla">
                        <a href="#galeria" target="_self" title="Imágenes" className="ancla-enlace">
                            <img src={iconoImgs} alt="icono imagenes" />
                        {t("ficha-img")}
                    </a>
                    </div>
                </div>

                <div className="col-xl-10 offset-xl-1" id="especie">
                    <h2 className="especie-latin">{this.state.species_info.species.taxa} <span className="cientifico">{this.state.species_info.species.authority}</span></h2>

                    <div className="row">
                        <div className="col-md-7 imagen">
                            {this.featured_image(this.state.species_info.images)}
                        </div>

                        <div className="col-md-5 ml-0 pl-0 datos" style={{paddingTop: '2.5rem'}}>
                            <ul style={{marginBottom: 0}}>
                                <li> <strong>{t("ficha-primReg")}</strong> {this.state.species_info.species.first_introduced_basin}, {this.state.species_info.species.first_record}</li>
                            </ul>

                            <ul style={{marginBottom: 0}}>
                                <li> <strong>{t("ficha-nomCom")}</strong> {this.common_names(this.state.species_info.common_names)}</li>
                            </ul>

                            <ul style={{marginBottom: 0}}>
                                <li> <strong>{t("ficha-reino")}</strong> {this.state.species_info.species.realm}</li>
                                <li> <strong>{t("ficha-filo")}</strong> {this.state.species_info.species.phylum}</li>
                                <li> <strong>{t("ficha-clase")}</strong> {this.state.species_info.species.class}</li>
                                <li> <strong>{t("ficha-orden")}</strong> {this.state.species_info.species.order}</li>
                                <li> <strong>{t("ficha-familia")}</strong> {this.state.species_info.species.family}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-xl-10 offset-xl-1 hr"/>

                <div className="col-xl-10 offset-xl-1" id="descripcion">
                    <h2 style={{marginBottom: '1rem'}}>{t("ficha-desc")}</h2>
                    <p>{this.state.species_info.species.description}</p>
                </div>

                <div className="col-xl-10 offset-xl-1 hr"/>

                <div className="col-xl-10 offset-xl-1" id="eicat">
                    <h2 style={{marginBottom: '1rem'}}>{t("ficha-eicat")}</h2>
                    {this.state.species_info.eicat_category.map(cat => {
                        return <p>{this.props.eicatCategories.filter(c => c.eicat_id === cat.eicat_id)[0].eicat}</p>
                    })}
                </div>

                <div className="col-xl-10 offset-xl-1 hr"/>

                <div className="col-xl-10 offset-xl-1" id="invasaqualist">
                    <h2 style={{marginBottom: '1rem'}}>{t("ficha-invasaqualist")}</h2>
                    {this.state.species_info.invasaqua_lists.map(list => {
                        return (
                                    <p><img style={{marginRight: '1rem'}} className="" src={check} alt={this.props.invasaquaLists.filter(l => l.invasaqua_id === list.invasaqua_id)[0].invasaqua} />{this.props.invasaquaLists.filter(l => l.invasaqua_id === list.invasaqua_id)[0].invasaqua}</p>
                            )
                    })}
                </div>

                <div className="col-xl-10 offset-xl-1 hr"/>

                <div className="col-xl-10 offset-xl-1" id="generales">
                    <h2 style={{marginBottom: '1rem'}} className="pt-5">{t("ficha-ref")}</h2>

                    <div className="accordion accordion-list" id="accordion">
                        {this.references(this.state.species_info.species_reference)}
                    </div>
                </div>
                <div className="col-xl-10 offset-xl-1" id="mapa">
                    <h2 className="pt-5">{t("ficha-mapa1")} {markers.length} {t("ficha-mapa2")}</h2>
                    <MapComponent tileType={'HEAT'} mapType={'MAP'} markers={markers} loading={false}/>
                </div>
                <div className="col-xl-10 offset-xl-1" style={{display: 'flex'}}>
                        <SibicCSV records={this.state.species_info} id_specie={this.props.sibicId} t={t}/>
                        <EasinCSV records={this.state.easinJsonData} id_specie={this.props.easinId} t={t}/>
                </div>
                <div className="col-xl-10 offset-xl-1" style={{fontSize: 11, fontStyle: 'italic'}}>* {t("ficha-csv-disc")}</div>

                {/* Especie detectada ... */}
                <div className="col-xl-10 offset-xl-1 mt-4" id="">
                    <div className="row">
                        {this.state.species_info.species.spanish_list === 1 &&
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-sm-3" style={{ textAlign: "center" }} id="">
                                        <img className="mt-2" src={specie_detected} alt="specie detected" />
                                    </div>
                                    <div className="col-sm-9 detected" id="">
                                        <ul className="pl-0" style={{ listStyle: "none" }}>
                                            <li><strong>{t("ficha-especieDest")}</strong></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }

                        {this.state.species_info.species.established_pop === 1 &&
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-sm-3" style={{ textAlign: "center" }} id="">
                                        <img className="mt-2" src={specie_population} alt="specie population" />
                                    </div>
                                    <div className="col-sm detected" id="">
                                        <ul className="pl-0" style={{ listStyle: "none" }}>
                                            <li><strong>{t("ficha-poblacion")}</strong></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.species_info.species.translocated === 1 &&
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-sm-3" style={{ textAlign: "center" }} id="">
                                        <img className="mt-2" src={specie_trasloced} alt="s" />
                                    </div>
                                    <div className="col-sm detected" id="">
                                        <ul className="pl-0" style={{ listStyle: "none" }}>
                                            <li><strong>{t("ficha-especieTranslocada")}</strong></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                {/* Listas especies ... */}
                <div className="col-xl-10 offset-xl-1 mt-4" id="">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-sm-3" style={{ textAlign: "center" }} id="">
                                    <img className="" src={this.state.species_info.species.european_list === 0 ? cross : check} alt="european list" />
                                </div>
                                <div className="col-sm detected" id="">
                                    <span>{t("ficha-listEu")}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-sm-3" style={{ textAlign: "center" }} id="">
                                    <img className="" src={this.state.species_info.species.spanish_list === 0 ? cross : check} alt="spanish list" />
                                </div>
                                <div className="col-sm detected" id="">
                                    <span>{t("ficha-listEsp")}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-sm-3" style={{ textAlign: "center" }} id="">
                                    <img className="" src={this.state.species_info.species.portuguese_list === 0 ? cross : check} alt="portuguese list" />
                                </div>
                                <div className="col-sm detected" id="">
                                    <span>{t("ficha-listPt")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-10 offset-xl-1 mt-4" id="">
                    <hr />
                </div>

                <div className="col-xl-10 offset-xl-1 mt-5" id="habitats">
                    <h2 className="mb-5">{t("habitats")}</h2>
                    <div className="row hab_imgs">
                        {this.habitats(this.state.species_info.habitats)}
                    </div>
                </div>
                <div className="col-xl-10 offset-xl-1 mt-4" id="">
                    <hr />
                </div>

                <div className="col-xl-10 offset-xl-1 mt-5" id="vias">
                    <h2 className="mb-5">{t("ficha-vias")}</h2>
                    <div className="row hab_imgs">
                        {this.pathways(this.state.species_info.pathways)}
                    </div>
                </div>
                <div className="col-xl-10 offset-xl-1 mt-4" id="">
                    <hr />
                </div>

                <div className="col-xl-10 offset-xl-1 mt-5" id="web_ref">
                    <h2 className="mb-3">{t("ficha-web")}</h2>
                    <ul style={{ listStyle: "none" }}>
                        {this.webpages(this.state.species_info.webpages)}
                    </ul>
                </div>
                <div className="col-xl-10 offset-xl-1 mt-4" id="">
                    <hr />
                </div>

                <div className="col-xl-10 offset-xl-1 mt-5 mb-5" id="galeria">
                    <h2 className="mb-3">{t("ficha-img")}</h2>
                    {this.images(this.state.species_info.images)}
                </div>
            </>

        );
    }
}

// export default Species;
export default withTranslation()(SpecieInfo);

const SpecieSpinner = props => (
    <div
        className="my_spinner"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 400,
            backgroundColor: '#fff'
        }}
    >
        <div>
            <Spinner className="spin m-3" animation="grow" variant="success" />
            <Spinner className="spin m-3" animation="grow" variant="info" />
            <Spinner className="spin m-3" animation="grow" variant="success" />
        </div>
    </div>
)
